import {
  commonCiEnv,
  commonDevEnv,
  InjectableConfig,
  WindowedObservable,
} from '@procom-labs/common'

const dev = {
  ...commonDevEnv,
  GTM_KEY: process.env.GTM_KEY || 'GTM-5JVF36B',
  rollbar: {
    captureUncaught: process.env.ROLLBAR_CAPTURE_UNCAUGHT
      ? process.env.ROLLBAR_CAPTURE_UNCAUGHT === 'true'
      : false,
    captureUnhandledRejections: process.env.ROLLBAR_CAPTURE_UNHANDLED
      ? process.env.ROLLBAR_CAPTURE_UNHANDLED === 'true'
      : false,
    accessToken: process.env.ROLLBAR_ACCESS_TOKEN || '123',
    enabled: process.env.ROLLBAR_ENABLED || 'false',
    payload: {
      environment: process.env.ROLLBAR_ENVIRONMENT || 'local',
    },
  },
  MIXPANEL_TOKEN: process.env.MIXPANEL_TOKEN ?? '',
  RESUME_BUILDER_API_URL:
    process.env.RESUME_BUILDER_API_URL ??
    'https://gw-dev-resume-parser-service.azurewebsites.net',
  RESUME_BUILDER_DOCX_URL:
    process.env.RESUME_BUILDER_DOCX_URL ??
    'https://gw-dev-resume-templator-service.azurewebsites.net',
  GORILLA_RESUME_API_URL:
    process.env.GORILLA_RESUME_API_URL ?? 'https://localhost:44317',
  ENABLE_RESUME_BUILDER_PARSER:
    process.env.ENABLE_RESUME_BUILDER_PARSER ?? 'false',
  SYNC_FUSION_EDITOR_KEY: process.env.SYNC_FUSION_EDITOR_KEY
    ? process.env.SYNC_FUSION_EDITOR_KEY
    : '',
  SYNC_FUSION_EDITOR_SERVICE_URL: process.env.SYNC_FUSION_EDITOR_SERVICE_URL
    ? process.env.SYNC_FUSION_EDITOR_SERVICE_URL
    : '',
  QUICKCONVERT_ALLOWED_ORGS: process.env.QUICKCONVERT_ALLOWED_ORGS ?? '',
}
const ci = {
  ...commonCiEnv,
  GTM_KEY: '#{GTM_KEY}#',
  rollbar: {
    accessToken: '#{Rollbar.FrontEndAccessToken}#',
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: '#{Rollbar.FrontEndEnabled}#',
    payload: {
      environment: '#{Rollbar.Environment}#',
    },
  },
  MIXPANEL_TOKEN: '#{MIXPANEL_TOKEN}#',
  RESUME_BUILDER_API_URL: '#{RESUME_BUILDER_API_URL}#',
  RESUME_BUILDER_DOCX_URL: '#{RESUME_BUILDER_DOCX_URL}#',
  GORILLA_RESUME_API_URL: '#{GORILLA_RESUME_API_URL}#',
  ENABLE_RESUME_BUILDER_PARSER: '#{ENABLE_RESUME_BUILDER_PARSER}#',
  SYNC_FUSION_EDITOR_KEY: '#{SYNC_FUSION_EDITOR_KEY}#',
  SYNC_FUSION_EDITOR_SERVICE_URL: '#{SYNC_FUSION_EDITOR_SERVICE_URL}#',
  QUICKCONVERT_ALLOWED_ORGS: '#{QUICKCONVERT_ALLOWED_ORGS}#',
}
export const environment = {
  ...(process.env.REACT_APP_STAGE === 'ci' ? ci : dev),
}

new WindowedObservable(InjectableConfig.Environment).publish(environment)
